(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('foo-image-text-carousel')) {
    customElements.define('foo-image-text-carousel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }
      init() {
        this.slides = Array.from(this.querySelectorAll('.iwt-carousel__slide'));
        if (this.slides.length < 2) return;
        this.track = this.querySelector('.iwt-carousel__track');
        this.controls = this.querySelector('.iwt-carousel__controls');
        this.toggle = this.querySelector('[data-toggle]');
        this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
        this.current = 0;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.abort = new AbortController();
        const listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: this.abort.signal });
        this.setAttribute('role', 'region');
        this.setAttribute('aria-roledescription', 'carousel');
        this.classList.add('is-ready');
        this.controls.hidden = false;
        this.slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', (i + 1) + ' of ' + this.slides.length);
        });
        listen(this.querySelector('[data-prev]'), 'click', () => this.go(this.current - 1));
        listen(this.querySelector('[data-next]'), 'click', () => this.go(this.current + 1));
        this.dots.forEach((dot) => listen(dot, 'click', () => this.go(Number(dot.dataset.slideTo))));
        if (this.toggle) listen(this.toggle, 'click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); });
        listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
        listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
        listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
        listen(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
        listen(document, 'visibilitychange', () => this.schedule());
        listen(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.updateToggle(); this.schedule(); });
        listen(this, 'keydown', (event) => {
          if (/INPUT|TEXTAREA|SELECT/.test(event.target.tagName) || event.target.isContentEditable) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        const viewport = this.querySelector('.iwt-carousel__viewport');
        listen(viewport, 'touchstart', (event) => {
          if (event.touches.length !== 1) { this.touch = null; return; }
          this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { passive: true });
        listen(viewport, 'touchend', (event) => {
          if (!this.touch) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.current + (dx < 0 ? 1 : -1));
        }, { passive: true });
        listen(viewport, 'touchcancel', () => { this.touch = null; }, { passive: true });
        listen(document, 'shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const slide = event.target.closest('.iwt-carousel__slide');
          if (slide) { this.editing = true; this.go(this.slides.indexOf(slide)); }
        });
        listen(document, 'shopify:block:deselect', (event) => {
          if (this.contains(event.target)) { this.editing = false; this.schedule(); }
        });
        this.resize = new ResizeObserver(() => this.setHeight());
        this.slides.forEach((slide) => this.resize.observe(slide));
        this.go(0);
        this.updateToggle();
      }
      go(index) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.inert = i !== this.current;
          slide.setAttribute('aria-hidden', String(i !== this.current));
        });
        const direction = getComputedStyle(this.track).direction === 'rtl' ? 1 : -1;
        this.track.style.transform = 'translateX(' + direction * this.current * 100 + '%)';
        this.querySelector('[data-current]').textContent = String(this.current + 1);
        this.dots.forEach((dot, i) => {
          if (i === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.setHeight();
        this.schedule();
      }
      setHeight() {
        if (this.slides && this.track) this.track.style.height = this.slides[this.current].offsetHeight + 'px';
      }
      updateToggle() {
        if (!this.toggle) return;
        this.toggle.textContent = this.paused ? 'Play' : 'Pause';
        this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || this.editing || document.hidden || !this.isConnected) return;
        this.timer = setTimeout(() => this.go(this.current + 1), Number(this.dataset.interval) || 4000);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        if (this.resize) this.resize.disconnect();
        if (this.abort) this.abort.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
